import React from 'react';
import * as MUI from '@material-ui/core';
import { useStyles } from './styles';

export const CategoryBody = ({ children, ...props }) => {
  const classes = useStyles(props);
  return (
    <>
      <MUI.Divider />
      <MUI.AccordionDetails className={classes.categoryBody}>
        {children}
      </MUI.AccordionDetails>
    </>
  );
}

export default CategoryBody;